<template>
    <div class="accordion-panel">
        <div class="accordion-panel__header" :class="{'active': isActive}" @click="headlineClickHandler">
            Texteingabe
        </div>

        <height-transition>
            <div class="accordion-panel__body" v-show="isActive">
                <div class="accordion-panel__body__inner">
                    <div class="text-settings">
                        <div class="input-wrapper input-wrapper--text">
                            <input type="text"
                                   name="text_input"
                                   placeholder="Geben Sie hier Ihren Text ein (bis zu 15 Zeichen)"
                                   @change="handleTextChange"
                                   @keyup="handleTextChange"
                                   v-model="text"
                                   :maxlength="maxLength"
                            >
                        </div>

                        <div class="input-wrapper input-wrapper--select">
                            <label :for="uniqid('font_family')">Schriftart</label>
                            <select name="select_font"
                                    :id="uniqid('font_family')"
                                    v-model="fontFamily"
                                    @change="handleFontFamilyChange"
                            >
                                <option v-for="fontFamilyOption in fontFamilyOptions"
                                        :value="fontFamilyOption"
                                        :key="fontFamilyOption"
                                        :style="{'font-family': fontFamilyOption}"
                                >
                                    {{ fontFamilyOption }}
                                </option>
                            </select>
                        </div>

                        <div class="input-wrapper input-wrapper--select">
                            <label :for="uniqid('font_family')">Schriftgröße</label>
                            <select name="select_fontsize"
                                    v-model="fontSize"
                                    @change="handleFontSizeChange"
                            >
                                <option v-for="fontSizeOption in fontSizeOptions"
                                        :value="fontSizeOption.value"
                                        :key="fontSizeOption.value"
                                >
                                    {{ fontSizeOption.label }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="panel-section-headline has-tooltip" @click="showColorModal = true">
                        Text – Farbauswahl
                    </div>
                    <color-selector :attribute="colorAttribute"
                                    :selected="selectedColor"
                                    @selected:color="colorSelectedHandler"
                    ></color-selector>
                </div>
            </div>
        </height-transition>

        <!-- Color Modal -->
        <ui-modal v-show="showColorModal" @close:clicked="showColorModal = false">
            <template v-slot:title>Text – Farbauswahl</template>
            <template v-slot:content>
                <p>
                    Bitte legen Sie hier die Farbe für Ihren Text fest.
                </p>
            </template>
        </ui-modal>
    </div>
</template>

<script>
    import AttributeTree        from "../../../expivi/attributes/AttributeTree"
    import AttributeValue       from "../../../expivi/attributes/AttributeValue"
    import {TextToImageBuilder} from "../../../gfx/TextToImageBuilder"
    import Attribute            from "../../../expivi/attributes/Attribute"

    export default {
        name:     "TextPanel",
        props:    {
            customization:  {
                required: true,
                type:     AttributeValue
            },
            position:       {
                required: true,
                type:     AttributeTree
            },
            colorAttribute: {
                required: true,
                type:     Attribute
            },
        },
        data:     function () {
            return {
                node:                  null,
                materialManager:       null,
                targetMaterial:        null,
                textAttribute:         null,
                textAttributeValuable: null,
                materialId:            null,
                texture:               null,
                builder:               null,
                showColorModal:        false,
                text:                  '',
                fontFamily:            'Abel',
                fontSize:              24,
                fontFamilyOptions:     ['Abel', 'Crete Round', 'Hind Madurai', 'Montserrat', 'Old Standard TT', 'Playfair Display', 'Roboto', 'Suranna'],
                fontSizeOptions:       [
                    {value: 38, label: '100%'},
                    {value: 24, label: '75%'},
                    {value: 16, label: '50%'},
                    {value: 10, label: '25%'},
                ],
                maxLength:             15,
            }
        },
        computed: {
            /**
             * Get the slug of the position
             */
            positionSlug: function () {
                return this.position.getRoot().getSlug()
            },

            /**
             * Returns the selected color as defined in the position's store.
             */
            selectedColor: function () {
                return this.$store.state[this.positionSlug].color
            },

            /**
             * Validates, if the text customization is actie
             */
            isActive: function () {
                return this.callStoreGetter('hasTextCustomization')
            },

            hasText: function () {
                return this.callStoreGetter('hasText')
            },

            hasFontFamily: function () {
                return this.callStoreGetter('hasFontFamily')
            },

            hasFontSize: function () {
                return this.callStoreGetter('hasFontSize');
            },

            /**
             * Get the text attribute value
             */
            textAttributeValue: function () {
                return this.text + ' @font:' + this.fontFamily + ' @size:' + parseFloat(this.fontSize)
            },
        },
        created:  function () {
            this.node    = this.position.filterByType('mytw_conf_position_text')
            this.builder = new TextToImageBuilder()


            if (this.node.hasAttributeValues()) {
                this.textAttribute         = this.node.getAttributeValues()[0]
                this.textAttributeValuable = this.textAttribute.getAttributeValueValuable()
                this.renderTextTexture()
            }
        },
        methods:  {
            /**
             * Call a store getter
             */
            callStoreGetter(getterName) {
                let slug = this.positionSlug
                return this.$store.getters[slug + '/' + getterName]
            },

            /**
             * Call a store mutation
             */
            callStoreMutation(mutationName, payload) {
                let slug = this.positionSlug
                return this.$store.commit(slug + '/' + mutationName, payload)
            },

            /**
             * Maps the updateCustomization mutation to the dynamic store module
             *
             * @param customization
             */
            updateCustomization: function (customization) {
                this.callStoreMutation('updateCustomization', customization)
            },

            /**
             * Maps the updateText mutation to the dynamic store module
             */
            updateText: function (text) {
                this.callStoreMutation('updateText', text)
            },

            /**
             * Maps the updateFontFamily mutation to the dynamic store module
             */
            updateFontFamily: function (fontFamily) {
                this.callStoreMutation('updateFontFamily', fontFamily)
            },

            /**
             * Maps the updateFontSize mutation to the dynamic store module
             */
            updateFontSize: function (fontSize) {
                this.callStoreMutation('updateFontSize', fontSize)
            },

            /**
             * Update the store with the updated text and rerender the texture
             */
            handleTextChange: function () {
                this.updateText(this.text);
                this.renderTextTexture();
            },

            /**
             * Update the store with the new font family and rerender the texture
             */
            handleFontFamilyChange: function () {
                this.updateFontFamily(this.fontFamily);
                this.renderTextTexture();
            },

            /**
             * Update the store with the changed font size and rerender the texture
             */
            handleFontSizeChange: function () {
                this.updateFontSize(this.fontSize);
                this.renderTextTexture();
            },

            /**
             * Enable the Text-Customization
             */
            headlineClickHandler: function () {
                if (this.isActive === false) {
                    this.$expiviReady.then(expivi => {
                        let customizationOptionsNode = this.position.filterByType('mytw_conf_position_customization')

                        this.updateCustomization(this.customization)
                        expivi.setProductAttribute(customizationOptionsNode.getId(), this.customization.getId())
                        this.handleTextChange()
                    })
                }
            },

            /**
             * Updates the text and font in expivi
             */
            renderTextTexture: function () {
                this.$expiviReady.then(expivi => {
                    this.texture = this.builder.buildTexture(
                        this.textAttributeValue,
                        this.textAttributeValuable.height,
                        this.textAttributeValuable.width_ratio,
                        this.textAttributeValuable.height / 2,
                        this.textAttributeValuable.position
                    )

                    //this.texture = this.createUvMapImage()
                    this.updateTexture()

                    expivi.setProductAttribute(this.node.getId(), this.textAttributeValue)
                })
            },


            /**
             * Update the texture on the 3D Model
             */
            updateTexture: function () {
                if (this.textAttributeValuable !== null && this.textAttributeValuable.material_id !== null && this.targetMaterial === null) {
                    this.$expiviReady.then(expivi => {
                        expivi.managers.resolveMaterialManager()
                            .then(materialManager => {
                                this.materialManager = materialManager

                                if (this.texture !== null) {
                                    this.targetMaterial = this.materialManager
                                        .resolveMaterialById(this.textAttributeValuable.material_id, resolvedMaterial => {
                                            this.targetMaterial             = resolvedMaterial
                                            this.targetMaterial.map         = this.texture
                                            this.targetMaterial.transaction = true
                                            this.targetMaterial.needsUpdate = true
                                            expivi._dispatch('render_frame')
                                        })
                                }
                            })
                    })
                } else if (this.targetMaterial !== null) {
                    this.targetMaterial.map         = this.texture
                    this.targetMaterial.needsUpdate = true
                    this.$expiviReady.then(expivi => expivi._dispatch('render_frame'))
                }
            },

            /**
             * Handle the color update by emitting the selected color back
             */
            colorSelectedHandler: function (color) {
                this.$emit('selected:color', color)
            },

            createUvMapImage: function () {
                let image   = new Image();
                let canvas  = document.createElement('canvas')
                let context = canvas.getContext('2d')

                canvas.style.display = 'none'
                document.body.appendChild(canvas)

                let texture = new THREE.Texture(canvas)

                image.onload = () => {
                    canvas.width  = image.width
                    canvas.height = image.height
                    context.clearRect(0, 0, canvas.width, canvas.height)
                    context.drawImage(image, 0, 0)
                }

                image.src           = 'ash_uvgrid03.jpg'
                texture.format      = THREE.RGBAFormat
                texture.minFilter   = THREE.NearestFilter
                texture.needsUpdate = true

                return texture
            }
        }
    }
</script>

<style scoped>
    * {
        will-change: height;
        transform: translateZ(0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    .height-expand-enter-active,
    .height-expand-leave-active {
        transition-duration: 1s;
        transition-property: height;
        transition-timing-function: ease-in-out;
        overflow: hidden;
    }

    .height-expand-enter,
    .height-expand-leave-to {
        height: 0;
    }
</style>
